<template>
	<div class="free-register">
		<div class="title-register">
			<h1>工程人专属的零代码业务平台助力工程企业快速数字化转型</h1>
			<div class="text">
				<p>
					一款以无代码、可视化为核心特性的数字化应用搭建平台，致力于帮助用户以低成本、短周期、高效率的方式实现各类数字化应用
				</p>
			</div>
			<!-- 注册 -->
			<section class="register">
				<div
					class="iphone-input"
					v-if="!token"
				>
					<img
						class="iphone position"
						src="https://static.bimcc.com/openim/Frame%20%2812%29061B1125536E92CCCCB8CCB70C9291B4.png"
					/>
					<el-input
						size="small"
						v-model="input"
						placeholder="请输入您的手机号"
					>
					</el-input>
				</div>
				<div
					class="button-box"
					v-if="!token"
				>
					<button
						class="button"
						@click="onLogin"
					>
						免费注册
					</button>
				</div>
			</section>
		</div>
		<section class="propaganda-list">
			<div
				class="item"
				v-for="item in dataList"
				:key="item.id"
			>
				<div class="icon-box">
					<img
						:src="item.icon"
						class="icon"
					/>
				</div>
				<div class="space-box"></div>
				<div class="title-text">
					<h6>{{ item.title }}</h6>
					<p>{{ item.text }}</p>
				</div>
			</div>
		</section>
		<section class="picture-box">
			<div class="img-bg">
				<img
					src="https://static.bimcc.com/openim/%E5%BA%95%E5%9B%BE4A5143DA940D3A6D26E08A6A870529BA.png"
					alt
				/>
			</div>
			<div class="img-animation">
				<img
					src="https://static.bimcc.com/openim/%E4%B8%AD%E9%97%B4%E6%82%AC%E6%B5%AE%E5%8A%A8%E5%9B%BECBD605CF15F29685DE80C06A2B24BD6F.png"
					alt
				/>
			</div>
			<div class="img-one">
				<img
					src="https://static.bimcc.com/openim/%E5%89%8D6532FE95882DEDAA047740DC12DB0E24.png"
					alt
				/>
			</div>
		</section>
	</div>
</template>

<script>
import { getToken } from '@/utils/tools';
export default {
	name: 'FreeRegistration',
	components: {},
	data() {
		return {
			token: getToken(),
			input: '',
			dataList: [
				{
					id: 0,
					title: '赋能企业数字化',
					text: '无纸化平台进行工程项目一站式精细化管理服务',
					icon: 'https://static.bimcc.com/openim/%E8%B5%8B%E8%83%BD%E4%BC%81%E4%B8%9A%E6%95%B0%E5%AD%97%E5%8C%966506023848D76A8912511CE09D0CE282.png'
				},
				{
					id: 1,
					title: '复杂业务个性化',
					text: '大型企业个性业务复杂，跨越技术与业务技术鸿沟',
					icon: 'https://static.bimcc.com/openim/%E5%A4%8D%E6%9D%82%E4%B8%9A%E5%8A%A1%E4%B8%AA%E6%80%A7%E5%8C%9601E22992318723FFCDCB72D88A77F21E.png'
				},
				{
					id: 2,
					title: '应用搭建简单化',
					text: '可视化无代码交互方式，即可快速搭建各种应用系统',
					icon: 'https://static.bimcc.com/openim/%E5%BA%94%E7%94%A8%E6%90%AD%E5%BB%BA%E7%AE%80%E5%8D%95%E5%8C%9688C00354524A246509598C3B4A48C91E.png'
				},
				{
					id: 3,
					title: '数字孪生可视化',
					text: '全场景可视化应用快速搭建实时数据看板、数字驾驶舱',
					icon: 'https://static.bimcc.com/openim/%E6%95%B0%E5%AD%97%E5%AD%AA%E7%94%9F%E5%8F%AF%E8%A7%86%E5%8C%96E8E73E494C424E737A209E290DCA92EB.png'
				}
			]
		};
	},
	methods: {
		onLogin() {
			window.location.href = `https://saas.bimcc.com/login?index=1&phone=${this.input}`;
		}
	}
};
</script>

<style lang="less" scoped>
.free-register {
	position: relative;
	width: 1200px;
	z-index: 2;
	.title-register {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		width: 53%;
		height: auto;
		padding-top: 154px;
		box-sizing: border-box;
		h1 {
			color: #131314;
			font-family: 'Source Han Sans CN';
			font-style: normal;
			font-weight: 700;
			font-size: 48px;
			line-height: 72px;
			-webkit-animation-duration: 1s;
			animation-duration: 1s;
			-webkit-animation-fill-mode: forwards;
			animation-fill-mode: forwards;
			webkit-animation-name: h1;
			animation-name: h1;
		}
		@keyframes h1 {
			0% {
				opacity: 0;
				transform: translate(0px, 100px) scale3d(0.8, 0.8, 1);
			}
			100% {
				opacity: 1;
				transform: translate(0px, 0px);
			}
		}
		.text {
			padding-top: 34px;
			box-sizing: border-box;
			p {
				width: 76%;
				color: #878787;
				font-family: 'Source Han Sans CN';
				font-style: normal;
				font-weight: 400;
				font-size: 20px;
				line-height: 30px;
			}
		}
		.register {
			display: flex;
			align-items: center;
			padding-top: 94px;
			box-sizing: border-box;
			height: 148px;
			.iphone-input {
				position: relative;
				width: 300px;
				height: 50px;
				border: 2px solid #789dff;
				border-radius: 7px;
				:deep(.el-input--small .el-input__inner) {
					height: 50px;
					padding-left: 49px;
					box-sizing: border-box;
					border: 1px solid #fff;
				}
				:deep(.el-input-group__append, .el-input-group__prepend, .el-input__inner) {
					background-color: #347eff;
					color: #ffffff;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 400;
					font-size: 16px;
					line-height: 24px;
					color: #d9d9d9;
				}
				.position {
					position: absolute;
					top: 15px;
					bottom: 16px;
					left: 15px;
					z-index: 999;
				}
			}
			.button-box {
				padding-left: 18px;
				box-sizing: border-box;
				.button {
					width: 125px;
					height: 50px;
					background: #337eff;
					border: 1px solid #337eff;
					color: #ffffff;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 400;
					font-size: 16px;
					line-height: 24px;
					border-radius: 7px;
					:deep(.el-button--warning) {
						border-color: #ffffff;
					}
				}
				.button:hover {
					box-shadow: 0 2px 12px 0 rgb(0 0 0 / 40%);
					transform: scale(1.1);
				}
			}
		}
	}
	.propaganda-list {
		display: flex;
		justify-content: space-between;
		width: 100%;
		padding-top: 86px;
		z-index: 99;
		position: relative;
		box-sizing: border-box;
		.item {
			position: relative;
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 24%;
			padding: 22px 25px 21px 20px;
			box-sizing: border-box;
			background: #ffffff;
			border-radius: 20px;
			box-shadow: 0px 6px 0px #789dff;
			transition: all 220ms ease-in-out, color 1ms;
			.icon-box {
				flex: 1;
				.icon {
					width: 100%;
				}
			}
			.space-box {
				width: 8%;
			}
			.title-text {
				width: 65%;
				h6 {
					color: #303030;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 500;
					font-size: 18px;
					line-height: 27px;
					white-space: nowrap;
				}
				p {
					padding-top: 2px;
					box-sizing: border-box;
					color: #8a8a8a;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 400;
					font-size: 12px;
					line-height: 18px;
				}
			}
		}
		.item:before {
			position: absolute;
			top: 0;
			right: 0;
			bottom: -30px;
			left: 0;
			border-radius: 8px;
			content: '';
		}
		.item:hover {
			transform: translateY(-30px);
		}
	}
	.picture-box {
		position: relative;
		position: absolute;
		top: 0%;
		left: 56%;
		width: 44%;
		height: 100%;
		padding-top: 250px;
		box-sizing: border-box;
		.img-bg {
			img {
				width: 100%;
			}
		}
		.img-animation {
			position: absolute;
			width: 50%;
			right: 24%;
			top: 23%;
			-webkit-animation: jump 7s infinite;
			animation: jump 7s infinite;
			z-index: 3;
			@keyframes jump {
				0%,
				100% {
					-webkit-transform: translateY(-4%);
					transform: translateY(-4%);
				}
				50% {
					-webkit-transform: translateY(5%);
					transform: translateY(5%);
				}
			}
			img {
				width: 100%;
			}
		}
		.img-one {
			position: absolute;
			width: 50%;
			right: 14%;
			top: 46%;
			z-index: 4;
			img {
				width: 50%;
			}
		}
	}
}
</style>
